import React from 'react';
import Suggestions from './component';

export default React.memo(Suggestions);
